<template>
    <div class="col-12 mx-auto">
        <div class="card">
            <dashboard-ctrl :componentName="componentName"
                            :showHideButton="showHideButton"
                            :showPinButton="showPinButton"
                            :showResizeIcon="showResizeIcon"
                            :size="size"
                            :headerTitle="titleKey"
                            :componentClass="'card-header bg-primary text-white'"
                            :showHeadful="showHeadful"
                            @hide="hide"
                            @resize="resize"
                            @pinned="pinned"
                            @unpinned="unpinned"></dashboard-ctrl>

            <div class="card-header" v-if="showSettingsBtn">
                <i class="fas fa-cogs pointer fa-2x float-right text-primary"
                   v-if="showSettingsBtn"
                   @click.stop="changeGridSettings"
                   data-toggle="tooltip"
                   :title="settingsTooltipText"></i>

                <grid-user-settings ref="userSettings"
                                    :schemaModelFields="schemaModelFields"
                                    :componentName="componentName"
                                    :useLabelAsTitle="true"
                                    :showUserSettings="true"
                                    :gridOptions="userSettings"
                                    v-if="showUserSettingsForm"
                                    @saveGridSettings="saveGridSettings"
                                    @loadGridSettings="loadGridSettings"
                                    @deleteGridSettings="deleteGridSettings"
                                    @userSettingsChanged="userSettingsChanged">
                </grid-user-settings>
            </div>

            <div class="btn-toolbar justify-content-between mt-3" role="toolbar">
                <div class="form-inline col-lg-6 col-md-12">
                    <vs-checkbox v-if="userId"
                                 v-model="eventsWithParticipationOnly"
                                 :name="'eventsWithParticipationOnly' + _uid"
                                 :id="'eventsWithParticipationOnly' + _uid"
                                 style="justify-content: flex-start !important"
                                 @change="onEventsWithParticipationChange">
                        {{ $t('registers.forms.eventsWithParticipationOnly') }}
                    </vs-checkbox>
                </div>

                <div class="input-group col-lg-6 col-md-12">
                    <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                    <button class="btn btn-secondary" @click.stop="massSearch">
                        <i class="fas fa-search"></i>
                        {{ $t('buttons.search.btnText') }}
                    </button>
                    <button class="btn btn-secondary"
                            @click.stop="clearFilters">
                        <i class="fas fa-times"></i>
                        {{ $t('buttons.clearFilters.btnText') }}
                    </button>
                </div>
            </div>

            <div class="card-body" id="grid">
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size="gridOptions.pageable.size"
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd"></kendo-datasource>

                <kendo-grid ref="grid"
                            :data-source-ref="'datasource1'"
                            :pageable="gridOptions.pageable"
                            :navigatable="gridOptions.navigatable"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :toolbar="toolbar"
                            :excel="gridOptions.excel"
                            :pdf="gridOptions.pdf"
                            :data-bound="dataBound">
                    <kendo-grid-column :field="'id'"
                                       :filterable="false"
                                       :title="$t('registers.forms.gridHeaders.id')"
                                       :width="100"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'registerEntityId'"
                                       :filterable="true"
                                       :title="$t('registers.forms.gridHeaders.registerEntityId')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="true">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'eventName'" :title="$t('registers.forms.gridHeaders.eventName')"
                                       :width="300" :lockable="true" :locked="true"></kendo-grid-column>
                    <kendo-grid-column :field="'name'" :title="$t('registers.forms.gridHeaders.name')" :width="300"
                                       :lockable="true" :locked="false" :hidden="isEnVersion"></kendo-grid-column>
                    <kendo-grid-column :field="'nameEn'"
                                       :title="$t('registers.forms.gridHeaders.nameEn')"
                                       :width="300"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'formType'"
                                       :title="$t('registers.forms.gridHeaders.formType')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="isEnVersion"></kendo-grid-column>
                    <kendo-grid-column :field="'formTypeEn'"
                                       :title="$t('registers.forms.gridHeaders.formTypeEn')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :hidden="!isEnVersion"></kendo-grid-column>
                    <kendo-grid-column :field="'isCompleted'"
                                       :title="$t('registers.forms.gridHeaders.isCompleted')"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false"
                                       :template="isCompletedCellTemplate"></kendo-grid-column>
                    <kendo-grid-column :field="'validFromUtc'"
                                       :title="$t('registers.forms.gridHeaders.validFrom')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :format="customDatetimeFormat"></kendo-grid-column>
                    <kendo-grid-column :field="'validToUtc'"
                                       :title="$t('registers.forms.gridHeaders.validTo')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false"
                                       :format="customDatetimeFormat"></kendo-grid-column>
                    <kendo-grid-column :field="'note'" :title="$t('registers.forms.gridHeaders.note')" :width="200"
                                       :lockable="true" :locked="false"></kendo-grid-column>
                    <kendo-grid-column :field="'status'"
                                       :title="$t('registers.forms.gridHeaders.status')"
                                       :width="140"
                                       :lockable="true"
                                       :locked="false"
                                       :template="statusCellTemplate"></kendo-grid-column>
                    <kendo-grid-column v-if="showBtns && hasCompletingRights"
                                       field="btnsColumn"
                                       :title="$t('registers.forms.gridHeaders.management')"
                                       :sortable="false"
                                       :filterable="false"
                                       :template="btnsTemplate"
                                       :width="140"
                                       :lockable="true"
                                       :locked="true"></kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
        <DetailsModal v-model="detailsModel" :show="showEventDetails" @onClose="onEventDetailsClose"></DetailsModal>
    </div>
</template>
<script src="https://kendo.cdn.telerik.com/2019.2.619/js/pako_deflate.min.js"></script>

<script>
    import Vue from 'vue';
    import JSZip from 'jszip';
    import GridUserSettings from '../../components/grid/UserSettings';
    import ControlBtnsTemplate from '../../components/dashboard/ControlBtnsTemplate';
    import BtnsTemplate from '../../components/grid/StandardBtnsTemplate';
    import personalizationService from '../../services/personalization.service';
    import { RegisterFieldValueQueryFilter, KendoGridPageSize } from '../../models/enums';
    import DetailsModal from '../dynamic/register/details.modal';
    import { mapGetters } from 'vuex';

    /*
        Renders the grid in "DejaVu Sans" font family, which is
        declared in kendo.common.css. It also declares the paths to the
        fonts below using <tt>kendo.pdf.defineFont</tt>, because the
        stylesheet is hosted on a different domain.
        */
    kendo.pdf.defineFont({
        'DejaVu Sans':
            'https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf',
        'DejaVu Sans|Bold':
            'https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf',
        'DejaVu Sans|Bold|Italic':
            'https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf',
        'DejaVu Sans|Italic':
            'https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf',
        WebComponentsIcons:
            'https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf'
    });

    export default {
        name: 'active-forms-grid',
        components: {
            'dashboard-ctrl': ControlBtnsTemplate,
            'grid-user-settings': GridUserSettings,
            DetailsModal
        },
        created: function () {
            window.JSZip = JSZip;
        },
        props: {
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: true,
                type: Boolean
            },
            showNewButton: {
                default: false,
                type: Boolean
            },
            showResizeIcon: {
                default: true,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showSettingsBtn: {
                default: true,
                type: Boolean
            },
            showBtns: {
                default: true,
                type: Boolean
            },
            relatedEventId: {
                default: 0,
                type: Number
            },
            returnUrl: {
                type: String,
                default: ''
            },
            dateFormat: {
                default: 'dd-MM-yyyy HH:mm:ss',
                type: String
            },
            userId: {
                type: String,
                default: null
            },
            showHeadful: {
                default: true,
                type: Boolean
            },
        },
        data() {
            return {
                componentName: 'ActiveFormsListGrid', // ������ �� ������������ �� �������� �� ������� �����������
                settingsTooltipText: this.$t('buttons.settings.tooltipText'),
                customSettingsLoaded: false,
                titleKey: 'registers.forms.activeForms',
                searchQuery: '',
                eventsWithParticipationOnly: false,
                detailsModel: null,
                showEventDetails: false,
                schemaModelFields: {
                    id: {
                        name: 'id',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.id'
                    },
                    registerEntityId: { name: 'registerEntityId', type: 'number', editable: false, nullable: true, visible: true, titleKey: 'registers.forms.gridHeaders.registerEntityId' },
                    formToRegisterEntityId: {
                        name: 'formToRegisterEntityId',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.id'
                    },
                    eventName: {
                        name: 'eventName',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.eventName'
                    },
                    name: {
                        name: 'name',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.name'
                    },
                    nameEn: {
                        name: 'nameEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.nameEn'
                    },
                    formType: {
                        name: 'formType',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.formType'
                    },
                    formTypeEn: {
                        name: 'formTypeEn',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.formTypeEn'
                    },
                    validFromUtc: {
                        name: 'validFromUtc',
                        type: 'date',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.validFromUtc'
                    },
                    validToUtc: {
                        name: 'validToUtc',
                        type: 'date',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.validToUtc'
                    },
                    note: {
                        name: 'note',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.note'
                    },
                    isTemplate: {
                        name: 'isTemplate',
                        type: 'boolean',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.isTemplate'
                    },
                    isCompleted: {
                        name: 'isCompleted',
                        type: 'boolean',
                        editable: false,
                        nullable: false,
                        visible: false,
                        titleKey: 'registers.forms.gridHeaders.isCompleted'
                    },
                    canEdit: {
                        name: 'canEdit',
                        type: 'boolean',
                        editable: false,
                        nullable: false,
                        visible: false,
                        titleKey: 'registers.forms.gridHeaders.canEdit'
                    },
                    deactivated: {
                        name: 'deactivated',
                        type: 'boolean',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.deactivated'
                    },
                    status: {
                        name: 'status',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.status'
                    },
                    allRecords: {
                        name: 'allRecords',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.allRecords'
                    },
                    validRecords: {
                        name: 'validRecords',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.validRecords'
                    },
                    deletedRecords: {
                        name: 'deletedRecords',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.deletedRecords'
                    },
                    deactivatedRecords: {
                        name: 'deactivatedRecords',
                        type: 'number',
                        editable: false,
                        nullable: false,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.deactivatedRecords'
                    },
                    creatorUsername: {
                        name: 'creatorUsername',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.creatorUsername'
                    },
                    createdAtUtc: {
                        name: 'createdAtUtc',
                        type: 'date',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.createdAtUtc'
                    },
                    updaterUsername: {
                        name: 'updaterUsername',
                        type: 'string',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.updaterUsername'
                    },
                    updatedAtUtc: {
                        name: 'createdAtUtc',
                        type: 'date',
                        editable: false,
                        nullable: true,
                        visible: true,
                        titleKey: 'registers.forms.gridHeaders.updatedAtUtc'
                    },
                    formEntityId: {
                        name: 'formEntityId',
                        type: 'number',
                        editable: false,
                        nullable: true,
                        visible: false,
                        titleKey: 'registers.forms.gridHeaders.deletedRecords'
                    }
                },
                gridOptions: { ...this.$store.getters.gridOptions,
                    excel: {
                        fileName: 'ActiveForms.xlsx',
                        allPages: false,
                        filterable: true,
                        collapsible: true
                    },
                    pdf: {
                        fileName: 'ActiveForms.pdf',
                        title: this.$t(this.titleKey),
                        subject: this.$t(this.titleKey),
                        creator: this.$store.userName,
                        allPages: false,
                        avoidLinks: true,
                        paperSize: 'A4',
                        margin: {
                            top: '2cm',
                            left: '1cm',
                            right: '1cm',
                            bottom: '1cm'
                        },
                        landscape: true,
                        repeatHeaders: true,
                        scale: 0.6
                    }
                },
                working: false,
                showUserSettingsForm: false
            };
        },
        methods: {
            dataBound(e) {
                if (!this.customSettingsLoaded) {
                    this.customSettingsLoaded = true;
                    this.loadGridSettings();
                }
            },
            dataSourceError(e) {
                this.$vs.notify({
                    title: this.$t('notifications.error'),
                    text: this.$helpers.kendoDataSourceErrorText(e),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return {models: kendo.stringify(options.models)};
                } else {

                    let newOptions = { request: options, eventsWithParticipationOnly: this.eventsWithParticipationOnly };
                    return kendo.stringify(newOptions);
                }
            },
            getGridOptions() {
                const grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    return grid.getOptions();
                }
            },
            saveGridSettings() {
                const gridSettings = this.getGridOptions();
                const grid = this.$refs.grid.kendoWidget();

                if (gridSettings && grid) {
                    this.$refs.userSettings.setGridSettings(gridSettings);

                    personalizationService
                        .saveGridSettings(this.componentName, gridSettings)
                        .then(response => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.responseStatusCode(response)),
                                text: this.$helpers.responseMessage(response),
                                color: 'success',
                                time: this.$store.getters.notificationDuration
                            });
                        })
                        .catch(error => {
                            this.$vs.notify({
                                title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                                text: this.$helpers.errorText(error),
                                color: this.$helpers.errorColor(error),
                                time: this.$store.getters.notificationDuration
                            })
                        });
                }
            },
            loadGridSettings() {
                personalizationService
                    .loadGridSettings(this.componentName)
                    .then(response => {
                        try {
                            var options = personalizationService
                                .mergePersonGridSettings(this.getGridOptions(), response.data.settings);

                            let grid = this.$refs.grid.kendoWidget();
                            if (options && grid) {
                                grid.setOptions(options);

                                if (options.pageable.size != grid.dataSource.options.pageSize) {
                                    grid.dataSource.pageSize(options.pageable.size);
                                    grid.refresh();
                                }

                                const userSettingsEditor = this.$refs.userSettings;
                                if (userSettingsEditor) {
                                    userSettingsEditor.setGridSettings(grid.getOptions());
                                }
                            }

                            this.customSettingsLoaded = true;
                        } catch (e) {
                            this.customSettingsLoaded = true;
                        }

                    })
                    .catch(error => {
                        this.customSettingsLoaded = true;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            deleteGridSettings() {
                personalizationService
                    .delteGridSettings(this.componentName)
                    .then(response => {
                        this.$router.go();
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            userSettingsChanged(userSettings, pageSizeChanged) {
                let grid = this.$refs.grid.kendoWidget();

                if (grid) {
                    try {
                        grid.setOptions(userSettings);
                        if (pageSizeChanged === true) {
                            if (userSettings.pageable.size == KendoGridPageSize.All) {
                                grid.dataSource.pageSize(grid.dataSource.total());
                            }
                            else {
                                grid.dataSource.pageSize(userSettings.pageable.size);
                            }
                            grid.refresh();
                        }
                    } catch (e) {
                        return;
                    }
                }
            },
            hasCompletingRights() {
                return true;
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            changeGridSettings() {
                this.showUserSettingsForm = !this.showUserSettingsForm;
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            resize(componentName, size) {
                this.$emit(
                    'resize',
                    componentName,
                    size,
                    this.$refs.grid.kendoWidget()
                );
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            hide(componentName) {
                this.$emit('hide', componentName);
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            pinned(componentName) {
                this.$emit('pinned', componentName);
            },
            // ������ �� ������������ �� �������� �� ������� �����������. ������� ��������� �� ���������� � �������� �� ��������� ��������(��������)
            unpinned(componentName) {
                this.$emit('unpinned', componentName);
            },
            datasorceRequestEnd(e) {
                if (e.type == 'read' && e.response) {
                }
            },
            statusCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' +
                    (dataItem.status.indexOf('Active') >= 0
                        ? 'badge-success'
                        : dataItem.status.indexOf('Passed') >= 0
                            ? 'badge-warning'
                            : 'badge-info') +
                    '">' +
                    kendo.htmlEncode(dataItem.status) +
                    '</span>';

                return templateHtml;
            },
            isCompletedCellTemplate: function (dataItem) {
                let templateHtml =
                    '<span class="badge ' +
                    (dataItem.isCompleted ? 'badge-success' : 'badge-warning') +
                    '">' +
                    kendo.htmlEncode(
                        dataItem.isCompleted ? this.$t('yes') : this.$t('no')
                    ) +
                    '</span>';

                return templateHtml;
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        returnUrl: this.returnUrl
                            ? this.returnUrl
                            : '/forms/active',
                        parentComponent: this.$refs.grid,
                        btns: !e.isCompleted
                            ? [
                                {
                                    name: 'complete',
                                    text: this.$t('buttons.complete.btnText'),
                                    tooltip: this.$t(
                                        'buttons.complete.btnText'
                                    ),
                                    class: 'btn btn-primary',
                                    icon: 'fas fa-check',
                                    show: this.hasCreateRights,
                                    clickHandler: this.completeBtnClick
                                },
                                {
                                    name: 'eventDetails',
                                    text: this.$t('buttons.eventDetails.btnText'),
                                    tooltip: this.$t('buttons.details.btnText'),
                                    class: 'btn btn-primary',
                                    icon: 'fas fa-eye',
                                    show: e.registerEntityId && this.claims.eventDetails.read,
                                    clickHandler: this.eventDetailsBtnClick
                                }
                            ]
                            : e.canEdit && e.formEntityId && e.formEntityId > 0
                                ? [
                                    {
                                        name: 'edit',
                                        text: this.$t('buttons.edit.btnText'),
                                        tooltip: this.$t('buttons.edit.btnText'),
                                        class: 'btn btn-primary',
                                        icon: 'fas fa-edit',
                                        show: this.hasUpdateRights,
                                        clickHandler: this.editBtnClick
                                    },
                                    {
                                        name: 'eventDetails',
                                        text: this.$t('buttons.eventDetails.btnText'),
                                        tooltip: this.$t('buttons.details.btnText'),
                                        class: 'btn btn-primary',
                                        icon: 'fas fa-eye',
                                        show: e.registerEntityId && this.claims.eventDetails.read,
                                        clickHandler: this.eventDetailsBtnClick
                                    }
                                ]
                                : !e.canEdit && e.formEntityId && e.formEntityId > 0
                                    ? [
                                        {
                                            name: 'details',
                                            text: this.$t('buttons.details.btnText'),
                                            tooltip: this.$t('buttons.details.btnText'),
                                            class: 'btn btn-primary',
                                            icon: 'fas fa-eye',
                                            show: true,
                                            clickHandler: this.detailsBtnClick
                                        },
                                        {
                                            name: 'eventDetails',
                                            text: this.$t('buttons.eventDetails.btnText'),
                                            tooltip: this.$t('buttons.details.btnText'),
                                            class: 'btn btn-primary',
                                            icon: 'fas fa-eye',
                                            show: e.registerEntityId && this.claims.eventDetails.read,
                                            clickHandler: this.eventDetailsBtnClick
                                        }
                                    ]
                                    : []
                    }
                };
            },
            completeBtnClick: function (args) {
                if (!this.hasCreateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push(
                    `/forms/complete?id=${args.formToRegisterEntityId}&name=${args.eventName}&returnUrl=${args.returnUrl}`
                );
            },
            editBtnClick: function (args) {
                if (!this.hasUpdateRights) {
                    return this.$router.push(`/unauthorized`);
                }

                this.$router.push(
                    `/forms/entryEdit?id=${args.formToRegisterEntityId}&entryId=${args.formEntityId}&name=${args.eventName}&returnUrl=${args.returnUrl}`
                );
            },
            detailsBtnClick: function (args) {
                let routeData = this.$router.resolve({ name: 'detailsFormEntry',
                    query: { id: args.formToRegisterEntityId, entryId: args.formEntityId, name: args.eventName, returnUrl: args.returnUrl } });
                window.open(routeData.href, '_blank');
            },
            eventDetailsBtnClick: function(args) {
                this.showDetailsModal(args, RegisterFieldValueQueryFilter.All);
            },
            showDetailsModal(args, filter) {
                this.$api.dynamicRegister
                    .getDetails(args.registerEntityId, filter)
                    .then(response => {
                        const model = response.data;
                        if (model) {
                            this.detailsModel = model;
                            this.showEventDetails = true;
                        }
                    })
                    .catch(error => {
                        this.detailsModel = null;
                        this.showEventDetails = false;

                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: this.$helpers.errorColor(error),
                            time: this.$store.getters.notificationDuration
                        })
                    });
            },
            onEventDetailsClose() {
                this.showEventDetails = false;
                this.detailsModel = null;
            },
            clearFilters() {
                this.searchQuery = '';
                personalizationService.claerState(this.componentName);
                personalizationService.clearFilters(this.$refs.grid.kendoWidget());
            },
            massSearch() {
                if (!this.searchQuery) {
                    this.$vs.notify({
                        title: this.$t('buttons.search.btnText'),
                        text: this.$t('emptySearchFilter'),
                        color: 'warning',
                        time: this.$store.getters.notificationDuration
                    })

                    return;
                }

                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                    if (filter) {
                        grid.dataSource.filter(filter);
                    }
                }
            },
            onEventsWithParticipationChange() {
                this.refresh();
            },
            refresh() {
                let grid = this.$refs.grid.kendoWidget();
                if (grid) {
                    grid.dataSource.read();
                }
            }
        },
        mounted() {
        },
        computed: {
            ...mapGetters(['dateTimeFormat', 'claims', 'isEnVersion']),
            customDatetimeFormat() {
                return `{0:${this.dateTimeFormat}}`
            },
            token: function () {
                return this.$store.getters.authToken;
            },
            userSettings() {
                let grid = this.$refs.grid.kendoWidget();
                return grid.getOptions();
            },
            toolbar: function () {
                return [
                    {
                        name: 'excel',
                        text: this.$t('buttons.excelExport.tooltipText')
                    }
                ];
            },
            transportSettings: function () {
                return {
                    read: {
                        url:
                            this.$store.getters.baseUrl +
                            '/api/dynamicForms/listActive/' +
                            this.userId || '',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                };
            },
            hasCreateRights() {
                 return this.$store.getters.claims.formSurveyEntity.create;
            },
            hasUpdateRights() {
                return this.$store.getters.claims.formSurveyEntity.update;
            }
        }
    };
</script>


<style>
    /*
            Use the DejaVu Sans font for display and embedding in the PDF file.
            The standard PDF fonts have no support for Unicode characters.
        */
    .k-pdf-export .k-grid {
        font-family: 'DejaVu Sans', 'Arial', sans-serif;
    }

    .k-pdf-export .k-filterable .k-grid-filter {
        display: none;
    }

    .k-pdf-export .k-with-icon .k-header-column-menu {
        display: none;
    }

    .k-grid .k-grid-header .k-header .k-link {
        height: auto;
    }

    .k-grid .k-grid-header .k-header {
        white-space: normal;
    }

    .k-grid-edit,
    .k-grid-details,
    .k-grid-delete,
    .k-grid-pdf,
    .k-grid-excel {
        padding: 0;
        margin-bottom: 2px;
    }
</style>
